package com.partejar.app.feature.account.data

import com.partejar.app.core.network.ApiConfig
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import kotlinx.serialization.Serializable

@Serializable
data class AccountDeletionReceipt(
    val id: Long,
    val status: String,
    val requestedAt: String,
    val requiresWorkspaceResolution: Boolean,
    val alreadyRequested: Boolean
)

class AccountDeletionRepository(
    private val client: HttpClient,
    private val apiConfig: ApiConfig
) {
    suspend fun request(): AccountDeletionReceipt {
        val response = client.post(apiConfig.endpoint("/usuarios/me/exclusao")) {
            contentType(ContentType.Application.Json)
            setBody(AccountDeletionConfirmation(true))
        }
        if (response.status != HttpStatusCode.OK) {
            throw IllegalStateException("Não foi possível registrar a solicitação.")
        }
        return response.body()
    }
}

@Serializable
private data class AccountDeletionConfirmation(val confirmed: Boolean)
